import { render, staticRenderFns } from "./CollidersModule.vue?vue&type=template&id=2b75b95e&"
import script from "./CollidersModule.vue?vue&type=script&lang=js&"
export * from "./CollidersModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports